import type { SavingEnvelopesCountryConfig } from './SavingEnvelopesConfig';

export const savingEnvelopes: SavingEnvelopesCountryConfig = {
    targetClientId: 'C02345N6',
    envelopeNameLength: 35,
    amountInputMaxLength: 12,
    envelopeNameMatchString: /^$|^[a-zA-Z0-9 /\-?:().,'+]+$/.toString(),
    envelopeNameErrorTranslationKey: 'saving:savingEnvelopes.errors.CHARACTER_NOT_PERMITTED',
};
